export default function BottomNav({ page, setPage }) {
  return (
    <div className="bottom-nav">
      <div
        className={page === "home" ? "active" : ""}
        onClick={() => setPage("home")}
      >
        🏠
      </div>

      <div
        className={page === "profile" ? "active" : ""}
        onClick={() => setPage("profile")}
      >
        👤
      </div>
    </div>
  );
}